import { FadeIn } from "../FadeIn";
import { Counter } from "../Counter";
import { useT } from "../../lib/i18n";

const STATS = [
  { value: 2400, suffix: "+", labelKey: "stat.clients" },
  { value: 32,   suffix: "",  labelKey: "stat.countries" },
  { value: 18,   suffix: "",  labelKey: "stat.projects" },
  { value: 75,   suffix: "+", labelKey: "stat.brands" },
];

const MARQUEE_NAMES = [
  "France.tv", "Canal+", "EDF", "Decathlon", "Groupama",
  "L'Équipe", "FFCK", "BBC", "Région AURA",
];

export const StatsSection = () => {
  const t = useT();

  return (
    <section
      data-testid="stats-section"
      className="bg-ink relative grain hidden md:block"
    >
      <div className="container-x py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 gap-12">
        {STATS.map((s, i) => (
          <FadeIn key={s.labelKey} delay={i * 0.08}>
            <div data-testid={`stat-${i}`}>
              <div className="font-display text-6xl md:text-7xl text-bone tracking-[-0.03em]">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-3 eyebrow">{t(s.labelKey)}</div>
            </div>
          </FadeIn>
        ))}
      </div>
      {/* Client name marquee bridges stats to Services */}
      <div className="border-t border-bone/8 overflow-hidden py-6">
        <div className="marquee">
          <div className="marquee-track text-bone/45 font-display text-2xl md:text-3xl italic items-center">
            {Array.from({ length: 2 }).map((_, k) =>
              MARQUEE_NAMES.map((name) => (
                <span key={`${k}-${name}`} className="inline-flex items-center gap-12 shrink-0">
                  {name}
                  <span className="text-bone/15">·</span>
                </span>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
